import { NgModule } from '@angular/core';
import {
    MdsAppbarComponent,
    MdsAutocompleteComponent,
    MdsBasicListComponent,
    MdsButtonComponent,
    MdsCardComponent,
    MdsCheckboxComponent,
    MdsChipComponent,
    MdsDateRangePickerComponent,
    MdsDatepickerComponent,
    MdsDialogActionsComponent,
    MdsDialogComponent,
    MdsDialogContentComponent,
    MdsDividerComponent,
    MdsDropdownComponent,
    MdsExpansionPanelComponent,
    MdsGlobalSideNavComponent,
    MdsGlobalSideNavContainerComponent,
    MdsGlobalSideNavContentComponent,
    MdsGlobalSideNavOptionsComponent,
    MdsIconButtonComponent,
    MdsIconComponent,
    MdsMenuComponent,
    MdsNavListComponent,
    MdsPaginatorComponent,
    MdsProgressBarComponent,
    MdsRadioGroupComponent,
    MdsSelectionListComponent,
    MdsSkeletonLoadComponent,
    MdsSlideToggleComponent,
    MdsSpinnerComponent,
    MdsTabComponent,
    MdsTabGroupComponent,
    MdsTableComponent,
    MdsTagComponent,
    MdsTextFieldComponent,
    MdsTextareaComponent,
} from '@medpacesoftwaredevelopment/designsystem';

@NgModule({
    declarations: [],
    imports: [
        MdsExpansionPanelComponent,
        MdsButtonComponent,
        MdsAppbarComponent,
        MdsSpinnerComponent,
        MdsDialogComponent,
        MdsAutocompleteComponent,
        MdsDatepickerComponent,
        MdsTabComponent,
        MdsCheckboxComponent,
        MdsTableComponent,
        MdsTextFieldComponent,
        MdsPaginatorComponent,
        MdsChipComponent,
        MdsRadioGroupComponent,
        MdsDropdownComponent,
        MdsTextareaComponent,
        MdsMenuComponent,
        MdsCardComponent,
        MdsDividerComponent,
        MdsBasicListComponent,
        MdsGlobalSideNavComponent,
        MdsSlideToggleComponent,
        MdsTagComponent,
        MdsProgressBarComponent,
        MdsNavListComponent,
        MdsGlobalSideNavContainerComponent,
        MdsGlobalSideNavOptionsComponent,
        MdsGlobalSideNavContentComponent,
        MdsDialogContentComponent,
        MdsDialogActionsComponent,
        MdsTabGroupComponent,
        MdsSelectionListComponent,
        MdsDateRangePickerComponent,
        MdsSkeletonLoadComponent,
        MdsIconComponent,
        MdsIconButtonComponent,
    ],
    exports: [
        MdsButtonComponent,
        MdsAppbarComponent,
        MdsSpinnerComponent,
        MdsDialogComponent,
        MdsAutocompleteComponent,
        MdsDatepickerComponent,
        MdsTabComponent,
        MdsCheckboxComponent,
        MdsTableComponent,
        MdsTextFieldComponent,
        MdsPaginatorComponent,
        MdsChipComponent,
        MdsRadioGroupComponent,
        MdsIconComponent,
        MdsDropdownComponent,
        MdsExpansionPanelComponent,
        MdsTextareaComponent,
        MdsMenuComponent,
        MdsCardComponent,
        MdsDividerComponent,
        MdsProgressBarComponent,
        MdsNavListComponent,
        MdsGlobalSideNavComponent,
        MdsSlideToggleComponent,
        MdsTagComponent,
        MdsGlobalSideNavContainerComponent,
        MdsGlobalSideNavOptionsComponent,
        MdsGlobalSideNavContentComponent,
        MdsDialogContentComponent,
        MdsDialogActionsComponent,
        MdsTabGroupComponent,
        MdsSelectionListComponent,
        MdsDateRangePickerComponent,
        MdsSkeletonLoadComponent,
        MdsIconButtonComponent,
    ],
    providers: [],
})
export class MdsModule {}
